module.exports = __webpack_public_path__ + "static/media/20.ed074c4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/20.jpg
// module id = 581
// module chunks = 0